module.exports = __webpack_public_path__ + "img/tactician.4fb8d549.png";